// Display-only title case for text dealers type in (names, organizations, addresses),
// so ALL CAPS and all-lowercase entries read consistently. The stored value is untouched.
// Acronyms can't be told apart from shouting, so "YMCA" shows as "Ymca".

// Lowercase unless first in the text
const SMALL_WORDS = new Set([ 'a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'in', 'of', 'on', 'or', 'the', 'to', 'via' ]);

const titleCase = (str?: string | null): string => {
  if (!str) return '';

  let first = true;
  // A word runs between spaces, slashes and hyphens; leading punctuation like "(" is skipped,
  // and a word starting with a digit ("1st", "80516") is left as is.
  return str.toLowerCase().replace(/[^\s/-]+/g, (word) => {
    const keepLower = !first && SMALL_WORDS.has(word);
    first = false;
    return keepLower ? word : word.replace(/^([^a-z0-9à-ÿ]*)([a-zà-ÿ])/, (_, lead, letter) => lead + letter.toUpperCase());
  });
};

export default titleCase;

// Sentence case for longer free text (funding purpose): everything lowercase except the first
// letter of each sentence. Proper nouns and acronyms are lowered too ("Ford" shows as "ford").
export const sentenceCase = (str?: string | null): string => {
  if (!str) return '';
  return str.toLowerCase().replace(/(^|[.!?]\s+)([^a-z0-9à-ÿ]*)([a-zà-ÿ])/g, (_, start, lead, letter) => start + lead + letter.toUpperCase());
};
